import type { FirstClassDocument } from '../../types';
import getFormattedDate from './getFormattedDate';
import parsePublishedDate from './parsePublishedDate';

export default function formatPublishedDate(
  publishedDate: NonNullable<FirstClassDocument['published_date']>,
): string {
  return getFormattedDate(parsePublishedDate(publishedDate));
}
